"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateList = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const CheckBox_1 = require("../../CheckBox");
const Icon_1 = require("../../Icon");
const LoadingOverlay_1 = require("../../LoadingOverlay");
const Table_1 = require("../../Table");
const messages_1 = require("./messages");
const tableRateListConfig_1 = require("./tableRateListConfig");
const utils_1 = require("./utils");
require("./index.scss");
const className = 'rate-list';
class RateListClass extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            searchText: this.props.searchText || '',
            isActiveOnly: this.props.isActiveOnly || false,
        };
        this.submitForm = () => {
            if (!this.props.isSubmitButtonDisable) {
                const { searchText, isActiveOnly, } = this.state;
                this.props.onSubmit({
                    searchText,
                    isActiveOnly,
                });
            }
        };
        this.handleSetSort = (data) => {
            var _a;
            (_a = this.props) === null || _a === void 0 ? void 0 : _a.setSort(data);
        };
        this.handleSubmitForm = (event) => {
            event.preventDefault();
            this.submitForm();
        };
        this.handleSearchTextChange = (event) => {
            const { value } = event.target;
            this.setState({ searchText: value }, this.submitForm);
        };
        this.handleIsOnlyActiveChange = () => {
            this.setState({ isActiveOnly: !this.state.isActiveOnly }, this.submitForm);
        };
    }
    render() {
        const { modificators, isLoading, isDirty, tableColumns, tableData, sortBy, sortOrder, } = this.props;
        const { searchText, isActiveOnly } = this.state;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        const loadingOverlayProps = {
            isLoading: isLoading || isDirty,
            hideLoader: !isLoading,
            loadingMessage: isLoading ? undefined : '',
            modificators: 'top',
        };
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("form", { className: `${className}__form`, onSubmit: this.handleSubmitForm },
                react_1.default.createElement("div", { className: `${className}__icon` },
                    react_1.default.createElement(Icon_1.Icon, { name: 'search' })),
                react_1.default.createElement("div", { className: `${className}__search` },
                    react_1.default.createElement("input", { type: 'text', placeholder: this.props.intl.formatMessage(messages_1.messages.searchPlaceholder), onChange: this.handleSearchTextChange, defaultValue: searchText })),
                react_1.default.createElement("div", { className: `${className}__buttons` }),
                react_1.default.createElement("div", { className: `${className}__checkboxes` },
                    react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/List:IsActiveOnly', defaultMessage: 'Active only' }), modificators: ['inline'], onChange: this.handleIsOnlyActiveChange, checked: isActiveOnly || false }))),
            react_1.default.createElement("div", { className: `${className}__list` },
                react_1.default.createElement(LoadingOverlay_1.LoadingOverlay, { ...loadingOverlayProps },
                    react_1.default.createElement(Table_1.Table, { columns: tableColumns, data: tableData, defaultSortBy: sortBy, defaultSortOrder: sortOrder, manualSortBy: true, setSort: this.handleSetSort, tableModificators: utils_1.tableModificators })))));
    }
}
RateListClass.defaultProps = {
    children: null,
    loading: false,
    errorMessages: [],
    isSubmitButtonDisable: false,
    onSubmit: () => { },
    tableColumns: tableRateListConfig_1.tableRateListConfig,
    tableData: [],
    tableTotal: 0,
    page: 0,
    pageSize: 10,
    sortBy: undefined,
    sortOrder: undefined,
    setPage: () => { },
    setSort: () => { },
};
exports.RateList = (0, react_intl_1.injectIntl)(RateListClass);
//# sourceMappingURL=index.js.map